var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08e8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShipPin",
    transform: "translate(-745 -284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1597",
    "data-name": "\\u9577\\u65B9\\u5F62 1597",
    width: 42,
    height: 42,
    transform: "translate(745 284)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3100",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3100",
    transform: "translate(-16.955 -13.955)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_96",
    "data-name": "\\u6955\\u5186\\u5F62 96",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(764.955 300.955)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8239\\u30A4\\u30E9\\u30B9\\u30C8",
    transform: "translate(757 284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2002",
    "data-name": "\\u30D1\\u30B9 2002",
    d: "M400.539,226.37a21.665,21.665,0,0,1,2.946,3.24,19.694,19.694,0,0,1,3.986,11.916V260.25a.57.57,0,0,1-.57.57H394.18a.57.57,0,0,1-.57-.57V241.539a19.7,19.7,0,0,1,3.986-11.916,21.809,21.809,0,0,1,2.944-3.24",
    transform: "translate(-391.582 -223.761)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2003",
    "data-name": "\\u30D1\\u30B9 2003",
    d: "M400.259,267.828h9.52a.652.652,0,0,0,.649-.652V250.057a18.212,18.212,0,0,0-3.689-11.024c-.177-.241-.355-.469-.53-.687a1.536,1.536,0,0,0-2.381,0c-.175.218-.352.449-.53.687a18.211,18.211,0,0,0-3.689,11.024v17.119A.652.652,0,0,0,400.259,267.828Z",
    transform: "translate(-396.06 -232.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2004",
    "data-name": "\\u30D1\\u30B9 2004",
    d: "M394.568,218.689a21.672,21.672,0,0,1,2.946,3.24,19.7,19.7,0,0,1,3.986,11.916v18.724a.57.57,0,0,1-.57.57h-12.72a.57.57,0,0,1-.57-.57V233.858a19.7,19.7,0,0,1,3.986-11.916,21.808,21.808,0,0,1,2.944-3.24m0-2.609a22.62,22.62,0,0,0-8.957,17.778v22.851a.728.728,0,0,0,.73.728h2.3a.725.725,0,0,0,.728-.728V256.3a.951.951,0,0,1,.951-.951h8.493a.948.948,0,0,1,.951.951v.413a.728.728,0,0,0,.73.728h2.3a.728.728,0,0,0,.73-.728V233.858a22.619,22.619,0,0,0-8.96-17.778Z",
    transform: "translate(-385.61 -216.08)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_714",
    "data-name": "\\u9577\\u65B9\\u5F62 714",
    width: 8.684,
    height: 11.156,
    rx: 4.342,
    transform: "translate(4.647 11.696)",
    fill: "#fff",
    stroke: "#bbb",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_715",
    "data-name": "\\u9577\\u65B9\\u5F62 715",
    width: 8.537,
    height: 10.491,
    rx: 1.96,
    transform: "translate(4.69 23.865)",
    fill: "#585959",
    stroke: "#bbb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_9",
    "data-name": "\\u6955\\u5186\\u5F62 9",
    cx: 1.438,
    cy: 1.438,
    r: 1.438,
    transform: "translate(7.52 19.005)",
    fill: "#585959"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_10",
    "data-name": "\\u6955\\u5186\\u5F62 10",
    cx: 0.669,
    cy: 0.669,
    r: 0.669,
    transform: "translate(8.288 6.511)",
    fill: "#5e1213"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_716",
    "data-name": "\\u9577\\u65B9\\u5F62 716",
    width: 6.295,
    height: 2.071,
    rx: 1.036,
    transform: "translate(5.842 12.834)",
    fill: "#418bc4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_717",
    "data-name": "\\u9577\\u65B9\\u5F62 717",
    width: 6.295,
    height: 2.071,
    rx: 1.036,
    transform: "translate(5.842 15.75)",
    fill: "#418bc4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_718",
    "data-name": "\\u9577\\u65B9\\u5F62 718",
    width: 4.452,
    height: 1.204,
    rx: 0.602,
    transform: "translate(6.501 29.294) rotate(90)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_719",
    "data-name": "\\u9577\\u65B9\\u5F62 719",
    width: 4.452,
    height: 1.204,
    rx: 0.602,
    transform: "translate(12.619 29.296) rotate(90)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_720",
    "data-name": "\\u9577\\u65B9\\u5F62 720",
    width: 4.325,
    height: 2.632,
    transform: "translate(6.795 30.206)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_721",
    "data-name": "\\u9577\\u65B9\\u5F62 721",
    width: 7.32,
    height: 2.251,
    rx: 1.126,
    transform: "translate(5.299 24.466)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_722",
    "data-name": "\\u9577\\u65B9\\u5F62 722",
    width: 7.32,
    height: 0.857,
    rx: 0.428,
    transform: "translate(5.299 27.065)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_723",
    "data-name": "\\u9577\\u65B9\\u5F62 723",
    width: 4.325,
    height: 0.73,
    transform: "translate(6.795 20.093)",
    fill: "#585959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_724",
    "data-name": "\\u9577\\u65B9\\u5F62 724",
    width: 0.603,
    height: 7.522,
    transform: "translate(5.9 33.287)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_725",
    "data-name": "\\u9577\\u65B9\\u5F62 725",
    width: 0.603,
    height: 7.522,
    transform: "translate(11.414 33.287)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_726",
    "data-name": "\\u9577\\u65B9\\u5F62 726",
    width: 6.115,
    height: 1.057,
    transform: "translate(5.9 39.752)",
    fill: "#2f302f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_727",
    "data-name": "\\u9577\\u65B9\\u5F62 727",
    width: 1.945,
    height: 1.691,
    transform: "translate(7.986 27.669)",
    fill: "#2f302f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipPin);
export default __webpack_public_path__ + "static/media/ShipPin.b55d2da5417a21c7658f063ec760c102.svg";
export { ForwardRef as ReactComponent };